import PageTitle from 'components/PageTitle';

const TopNavigation = () => {
  return (
    <div className="flex h-[66px] items-center justify-center border-b-1 border-b-neutral-200 bg-white select-none">
      <PageTitle text="EdLight Research" />
    </div>
  );
};

export default TopNavigation;
